 <template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'Appearance'}">
              <h4 class="m-dir-2">
                 {{label.pages.Appearance}}
              </h4>
            </b-link>
            /
            <h4 class="m-dirR-2">
              {{ $route.meta.label }}
            </h4>
          </b-col>
          <b-col cols="2" class="dir-text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title=" label.pages.Appearance"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <b-tabs
              nav-class="tab-title"
              active-nav-item-class="tab-title-active"
              fill
              justified
              pills
              v-model="selectedTab"
          >

          <!-- Static Pages  -->
            <b-tab v-for="page in staticPages" :key="page.id">
              <template #title>
                {{ page.title }}
              </template>
              <b-row class="tab-content">
                <b-col cols="6">
                  <b-row v-show="contentLanguageAccess == 1">
                    <b-col cols="4">
                      <label for="language" class="ps_label">
                        {{label.pages.contentLanguage}}
                        <span class="ps_label_star">*</span>
                      </label>
                    </b-col>
                    <b-col cols="8">
                      <v-select
                        input-id="language"
                        :options="languages"
                        v-model="selectedLanguage"
                        :reduce="group => group.id"
                        :clearable="false"
                        size="sm"
                        class="ps_select"
                        @input="setLanguage"
                      >
                      </v-select>
                    </b-col>
                  </b-row>
                  <b-row class="my-4">
                    <b-col cols="4">
                      <label for="title" class="ps_label">
                        {{label.form.title}}
                        <span class="ps_label_star">*</span>
                      </label>
                    </b-col>
                    <b-col class="align-self-center" cols="8">
                      <b-form-input id="title" size="md" v-model="page.title"/>
                    </b-col>
                  </b-row>
                  <b-row class="my-4">
                    <b-col cols="4">
                      <label for="name" class="ps_label">
                        {{label.form.pageAddress}}
                      </label>
                    </b-col>
                    <b-col class="text-start" cols="8">
                      <b-form-input id="name" size="md" dir="ltr" v-model="page.name" disabled/>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="6">
                  <b-row>
                    <b-col cols="8">
                      <div class="dz-edit d-flex align-items-center" v-if="page.imageAddress !== null">
                        <img v-if="refreshImage" :src="page.imageAddress" />
                        <b-button
                            variant="ps-warning"
                            size="sm"
                            class="dz-clear-btn mx-1 px-3 py-1"
                            @click="showUploader(page)"
                        >
                          <b-icon-pencil-square />
                          {{label.buttons.editImage}}
                        </b-button>
                      </div>
                      <b-button
                          v-else
                          variant="ps-base"
                          size="sm"
                          class="dz-clear-btn mx-4 px-3 py-1 mt-5 ps-transform"
                          @click="showUploader(page)"
                      >
                        <b-icon-cloud-upload-fill class="ms-1" />
                        {{label.buttons.uploadImage}}
                      </b-button>
                    </b-col>
                    <b-col cols="4">
                      <b-row class="mt-5">
                        <b-col cols="auto">
                          <label for="isConfirm" class="ps_label pe-2">
                            {{label.form.display}}
                          </label>
                        </b-col>
                        <b-col >
                          <label class="ps-switch">
                            <input id="isConfirm" type="checkbox" v-model="page.isConfirm">
                            <span class="slider round"></span>
                          </label>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="12">
                  <b-row class="my-4">
                    <b-col cols="2">
                      <label for="shortDescription" class="ps_label">
                        {{label.pages.summary}}
                        <span class="ps_label_star">*</span>
                      </label>
                      <b-icon
                          icon="question-circle-fill"
                          scale="0.9"
                          variant="ps-base"
                          class="me-2 mouse-question"
                          :id="'pageContentGuide-' + page.id"
                      />
                      <b-popover
                        boundary="#app"
                        placement="top"
                        noninteractive
                        triggers="hover"
                        :target="'pageContentGuide-' + page.id"
                        dir="rtl"
                      >
                        {{ label.guide.pageMetaTag }}
                      </b-popover>
                    </b-col>
                    <b-col cols="10">
                      <b-form-textarea id="shortDescription" size="sm" rows="2" v-model="page.shortDescription"/>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12">
                  <b-row class="mb-3">
                    <b-col cols="12">

                      <label for="text" class="ps_label pe-2">
                        {{label.pages.content}}
                        <small class="me-1">
                         ({{ label.captions.pageContent }})
                        </small>
                      </label>
                      <DxHtmlEditor v-model="page.text" :height="editorHeight" >
                        <DxMediaResizing :enabled="mediaResize" />
                        <DxImageUpload
                                :tabs="imageUploadType"
                                :file-upload-mode="imageUploadMode"
                        />
                        <DxToolbar :multiline="multilineToolbar">
                          <DxItem :accepted-values="headerValues" name="header" />
                          <DxItem :accepted-values="sizeValues" name="size" />
                          <DxItem :accepted-values="fontValues" name="font" />
                          <DxItem name="separator" />
                          <DxItem
                                  v-for="toolbar in editorToolbar"
                                  :key="toolbar.id"
                                  :name="toolbar.name"
                          />
                        </DxToolbar>
                      </DxHtmlEditor>

                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <div class="d-flex justify-content-end">
                <button
                    @click="$router.go(-1)"
                    class="m-dir-2"
                    size="sm"
                    v-b-tooltip.hover
                    :title="label.pages.returnPage"
                >
                  <b-icon
                      icon="arrow-right-square-fill"
                      scale="2.1"
                      class="pt-1"
                      variant="ps-secondary-icon"
                  >
                  </b-icon>
                </button>
                <b-button
                    v-if="!loadingBtn"
                    variant="ps-success"
                    size="sm"
                    class="mx-1"
                    @click="editStaticPages(page)"
                >
                  <b-icon icon="check2-circle" class="ms-1"/>
                  {{label.buttons.saveChanges}}
                </b-button>
                <b-button
                    v-else
                    disabled
                    variant="ps-success"
                    size="sm"
                    class="mx-1"
                >
                  <b-spinner small></b-spinner>
                </b-button>
              </div>
            </b-tab>

      <!--  OtherPages tab -->
            <b-tab>
              <template #title>
                {{label.pages.anotherPages}}
              </template>
              <b-row class="tab-content pt-1 mt-0">
                <DxDataGrid
                    :show-row-lines="true"
                    :show-column-lines="true"
                    :show-borders="true"
                    :row-alternation-enabled="true"
                    :rtl-enabled="label.direction === 'rtl' ? true : false"
                    :data-source="OtherPages"
                    :columns="fields"
                    :remote-operations="true"
                    :column-auto-width="true"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    column-resizing-mode="widget"
                    :hover-state-enabled="true"
                    :noDataText="checkData"
                    @toolbar-preparing="onToolbarPreparing($event)"
                    key-expr="id"
                    class="ps_Table"
                    :height="dataGridHeight-70"
                >
                  <DxSearchPanel
                      :visible="true"
                      :width="240"
                      :placeholder="label.table.search"
                  />
                  <DxExport
                      :enabled="true"
                  />
                  <template #btnRGroup>
                    <b-row class="btnRLanguage-wrapper" v-show="contentLanguageAccess == 1">
                      <b-col cols="auto">
                        <label for="language" class="ps_label">
                          {{label.pages.contentLanguage}}
                        </label>
                      </b-col>
                      <b-col>
                        <v-select
                            input-id="language"
                            :options="languages"
                            v-model="selectedLanguage"
                            :reduce="group => group.id"
                            :clearable="false"
                            size="sm"
                            class="ps_select"
                            @input="setLanguage"
                        >
                        </v-select>
                      </b-col>
                    </b-row>
                  </template>
                  <template #btnGroup>
                    <div>
                      <b-row class="m-dir-2">
                        <b-col cols="auto" class="px-1">
                          <b-button
                              variant="ps-success"
                              class="py-1 pb-2"
                              size="sm"
                              v-b-tooltip.hover
                              :title="label.buttons.newPage"
                              @click="add"
                          >
                            <b-icon icon="plus" scale="2" color="#fff"></b-icon>
                          </b-button>
                        </b-col>
                        <b-col cols="auto" class="px-0">
                          <b-button
                              variant="ps-secondary"
                              class="py-1 pb-2"
                              size="sm"
                              v-b-tooltip.hover
                              :title="label.table.reload"
                              @click="reloadContent"
                          >
                            <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
                          </b-button>
                        </b-col>
                      </b-row>
                    </div>
                  </template>
                  <template #radif="{data}">
                    <div>
                      {{ data.rowIndex + 1 }}
                    </div>
                  </template>
                  <template #image="{data}">
                    <div>
                      <img :src="data.data.imageAddress" class="ps_table_inside_img"/>
                    </div>
                  </template>
                  <template #actions="{data}">
                    <b-row class="justify-content-center">
                      <b-col cols="auto" class="px-0">
                        <button
                            @click="edit(data)"
                            v-b-tooltip.hover
                            :title="label.pages.edit"
                        >
                          <b-icon icon="dash-square-fill" scale="1.1" variant="ps-edit-icon"></b-icon>
                        </button>
                      </b-col>
                      <b-col cols="auto" class="px-0 pe-2">
                        <button
                            @click="deleteModal(data)"
                            v-b-tooltip.hover
                            :title="label.pages.delete"
                        >
                          <b-icon icon="x-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
                        </button>
                      </b-col>
                    </b-row>
                  </template>
                  <DxLoadPanel :enabled="true"/>
                  <DxScrolling mode="virtual"/>
                </DxDataGrid>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!-- Delete Confirm Modal -->
    <b-modal
        :dir="label.direction"
        v-model="delModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center lh1 mb-0">
            {{ label.captions.deleteConfirm}}
            <br/>
            <strong>« {{ delTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="delModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-danger"
                size="sm"
                class="mx-1"
                @click="deletePage"
            >
            {{label.buttons.deleteConfirm}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <drop-zone-custom
        mode="hide"
        :isRequired="true"
        :add="dropZoneAction"
        :edit="!dropZoneAction"
        :editSrc="imageAddress"
    />
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import { devExtremeEditor } from "@/components/textEditor/devExtremeEditor";
import {dataGridMixin} from '@/components/dataGrid/dataGridMixin'
import dropZoneCustom from '@/components/DropZoneCustom'
import label from "@/plugins/StaticLabels.js";
import { contentLanguage } from "@/plugins/ContentLangMixin.js";

export default {
  name: 'ManagePages',
  mixins: [devExtremeEditor, dataGridMixin, contentLanguage],
  components: {
    dropZoneCustom
  },
  data() {
    return {
      refreshImage: true,
      dropZoneAction: true,
      label,
      fields: [
        {
          cellTemplate: 'radif',
          caption: label.table.row,
          allowSorting: false,
          allowFiltering: false,
          width: '100',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'actions',
          caption: label.table.actions,
          allowSorting: false,
          allowFiltering: false,
          width: '150',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'image',
          caption: label.table.image,
          allowSorting: false,
          allowFiltering: false,
          width: '150',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'title',
          caption: label.table.title,
          dataType: 'string',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'isConfirm',
          caption: label.table.status,
          dataType: 'boolean',
          cssClass: 'text-center align-middle'
        },
      ],
      image: null,
      imageName: null,
      imageAddress: null,
      editPage: [],
      editModal: false,
      editId: null,
      delModal: false,
      delId: null,
      delTitle: '',
      selectedTab: 0,
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      items: 'baseX/pages',
      loadingBtn: 'loadingBtn',
      imageUrl: 'imageUrl',
    }),
    staticPages() {
      return this.items.filter(this.staticPagesFilter)
    },
    OtherPages() {
      return this.items.filter(this.dynamicPagesFilter)
    },
  },
  watch: {
    postCheck() {
      if (this.postCheck === true) {
        this.addModal = false;
        this.editModal = false;
        this.delModal = false;
        this.reloadContent();
      }
    },
    imageUrl() {
      if (this.imageUrl && this.imageUrl.length > 0) {
        this.refreshImage = false
        this.imageName = this.imageUrl[0].fullPath
        this.imageAddress = this.imageUrl[0].fileAddress
        this.editStaticPages(this.editPage)
        this.$nextTick(() => {
          this.refreshImage = true
        });
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 1000);
      }
    },
  },
  methods: {
    staticPagesFilter(page) {
      return page.id <= 99
    },
    dynamicPagesFilter(page) {
      return page.id > 99
    },
    showUploader(page) {
      this.editPage = page
      this.$store.commit('setAddUploaderCheck', true);
      setTimeout(() => {
        this.$store.commit('setAddUploaderCheck', false);
      }, 1000);
    },
    editStaticPages(page) {
      this.$store.commit("setLoadingBtn", true);
      this.editId = page.id
      const formData = new FormData();
      if (page.title) {
        formData.append('Title', page.title);
      }
      if (page.name) {
        if (/[^A-Za-z/\d]/.test(page.name)) {
          const msg = 'لطفا آدرس صفحه را به صورت انگیسی و اعداد و بدون فاصله وارد کنید';
          this.$store.commit('setError', msg);
          this.$store.commit("setLoadingBtn", false);
        } else {
          if (page.name.indexOf("/") === 0 || page.name.indexOf("https") === 0 || page.name.indexOf("http") === 0 || page.name.indexOf("") === 0) {
            formData.append('Name', page.name);
          } else if (page.name.indexOf("/") !== 0) {
            formData.append('Name', "/" + page.name);
          }
        }
      }
      if (page.shortDescription) {
        formData.append('ShortDescription', page.shortDescription);
      }
      if (page.text) {
        formData.append('Text', page.text);
      }
      if (this.imageName) {
        formData.append('ImageName', this.imageName);
      }
      formData.append('IsConfirm', page.isConfirm);
      formData.append('languageId', this.selectedLanguage);
      const values = {
        id: this.editId,
        value: formData
      };
      this.$store.dispatch('baseX/editPage', values);
    },
    add() {
      this.$router.push({name: 'AddPage'})
    },
    edit(item) {
      this.$router.push({name: 'EditPage', params: {'id': item.data.id}})
    },
    deleteModal(item) {
      this.delId = item.data.id;
      this.delTitle = item.data.title;
      this.delModal = true;
    },
    deletePage() {
      this.$store.commit("setLoadingBtn", true);
      this.$store.dispatch('baseX/deletePage', this.delId);
    },
    reloadContent() {
      this.$store.dispatch('baseX/getPages', this.selectedLanguage);
    },
  },
  mounted() {
    this.reloadContent();
    setTimeout(() => {
      if (localStorage.getItem('tabIndex') && localStorage.getItem('tabIndex') != null) {
        this.selectedTab = Number(localStorage.getItem('tabIndex'));
      } else {
        this.selectedTab = 0;
      }
    }, 800);
  },
  beforeDestroy() {
    localStorage.setItem('tabIndex', this.selectedTab)
  }
}
</script>
